<template>
  <section>
    <h4 class="fs-20 font-medium mb-4">Logged dives</h4>

    <checkbox v-model="options.numDivesOptions.min5" @change="$emit('filter-changed')">
      5 - 30 dives
    </checkbox>
    <checkbox v-model="options.numDivesOptions.min31" @change="$emit('filter-changed')">
      31 - 50 dives
    </checkbox>
    <checkbox v-model="options.numDivesOptions.min51" @change="$emit('filter-changed')">
      51 - 100 dives
    </checkbox>
    <checkbox v-model="options.numDivesOptions.min101" @change="$emit('filter-changed')">
      100+ dives
    </checkbox>
  </section>
</template>

<script>
import Checkbox from '../../core/Checkbox'

export default {
  components: {
    Checkbox
  },
  inject: ['options']
}
</script>
